import React, { useEffect, useState } from 'react';
import { Game, Player } from '../../types/types';
import { Tabs, Tab , Box } from '@mui/material';
import PlayerDataGrid from '../DataGrid/PlayerDataGrid';
import { GridColDef, GridCellParams, GridRowParams, GridEvents, MuiEvent, GridCallbackDetails, GridRenderCellParams } from '@mui/x-data-grid';
import { TeamLogos, TeamsList } from '../../globals/Globals';
import { BattingTableColumns, BowlingTableColumns, BuildBattingTable, BuildBowlingTable } from '../../globals/TableFunctions';
import StrikeStatCard from '../Cards/StrikeStatCard';
import StrikeRateTable from './StrikeRateTable';
import { RegisterEvent } from '../../globals/Analytics';

export interface Props { 
    games: Game[];
    generalColumns: GridColDef[];
    generalRows: Object[];
    GeneralonCellClick: (params: GridCellParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails) => void;
    player: Player;
}

const TAB_NAMES = {
    0: "General",
    1: "Bowling",
    2: "Batting",
    3: "Strike Rate"
}

const MainTables = ({games, generalColumns, generalRows, GeneralonCellClick, player}:Props) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedTab(newValue);
        RegisterEvent({category: "SinglePlayerTablesTab", action: "change tab", label: `Changed main table tab to ${TAB_NAMES[newValue]}`,value: newValue})
    };

    const bowlingTableRows = BuildBowlingTable(games);
    const battingTableRows = BuildBattingTable(games);

    return <Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: "1rem" , display: "flex", justifyContent: "flex-start", marginTop: "1rem  "}}>
            <Tabs value={selectedTab} onChange={handleChange} variant="scrollable" style={{marginBottom: "1rem"}}>
                <Tab label="General" />
                <Tab label="Bowling" />
                <Tab label="Batting" />
                <Tab label="Strike Rate" />
            </Tabs>
        </Box>
        {selectedTab === 0 ? <PlayerDataGrid height={600} columns={generalColumns} rows={generalRows} onCellClick={GeneralonCellClick}/> : null}
        {selectedTab === 1 ? <PlayerDataGrid height={600} columns={BowlingTableColumns} rows={bowlingTableRows} /> : null}
        {selectedTab === 2 ? <PlayerDataGrid height={600} columns={BattingTableColumns} rows={battingTableRows} /> : null}
        {selectedTab === 3 ? <div style={{display: "flex", columnGap: "0.5rem"}}>
                {/* <StrikeStatCard strikeStat={player.batStrikeStat} /><StrikeStatCard strikeStat={player.bwlStrikeStat} /> */}
                <StrikeRateTable player={player} />
            </div> 
            : null}
    </Box>
}

export default MainTables;